export const navigationMenu = () => {
    const body = document.querySelector('body');
    const header = document.querySelector('header');
    const desktopNavigationLinks = document.querySelectorAll('.navigation__link__wrapper:not(.basic-link)');
    const lvl2NavigationLinks = document.querySelectorAll('.navigation__link__lvl2__wrapper');

    const mobileNavigation = document.querySelector('.navigation__mobile');
    const mainMenu = mobileNavigation.querySelector('.navigation__mobile__main-menu');
    const navigationButton = document.querySelector('.navigation__button');
    const mobileNavigationLinks = mobileNavigation.querySelectorAll('.navigation__mobile__link');
    const mobileNavigationBack = mobileNavigation.querySelectorAll('.go-back');
    const navigationMobile = document.querySelector('.navigation__mobile');

    window.onresize = (event) => {
        if (window.innerWidth >= 1240) {
            navigationButton.classList.remove('navigation__button--active');
            navigationMobile.classList.remove('navigation__mobile--active');

            setTimeout(() => {
                mobileNavigation.querySelectorAll('.navigation__mobile__submenu').forEach(submenu => {
                    submenu.classList.add('d-none')
                });
                mainMenu.classList.remove('d-none');
            }, 200);
        }

        checkScroll();
    };

    window.addEventListener('click', () => {
        navigationClose();
        closeAllMenus();
        setTimeout(() => {
            closeAllLvl2Menus();
        }, 300);
    });

    header.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    const checkScroll = () => {
        if (mobileNavigation.classList.contains('navigation__mobile--active')) {
            body.classList.add('no-scroll');
        } else {
            body.classList.remove('no-scroll');
        }
    }

    desktopNavigationLinks.forEach(link => {
        link.querySelector('.navigation__link')?.addEventListener('click', (event) => {
            event.preventDefault();
            closeAllMenus();
            setTimeout(() => {
                closeAllLvl2Menus();
            }, 300);
            navigationOpen();
            link.classList.add('open-menu');
        });
    });

    lvl2NavigationLinks.forEach(link => {
        link.querySelector('.navigation__link')?.addEventListener('click', () => {
            closeAllLvl2Menus();
            link.classList.add('keep-open');
        });
    });

    navigationButton.addEventListener('click', () => {
        navigationButton.classList.toggle('navigation__button--active');
        navigationMobile.classList.toggle('navigation__mobile--active');

        setTimeout(() => {
            mobileNavigation.querySelectorAll('.navigation__mobile__submenu').forEach(submenu => {
                submenu.classList.add('d-none')
            });
            mainMenu.classList.remove('d-none');
        }, 200);
        checkScroll();
    });

    mobileNavigationLinks.forEach(button => {
        button.addEventListener('click', (event) => {
            const { lvl: level, menu, subMenu } = button.dataset;
            if (button.getAttribute('href') && button.getAttribute('href') != 'javascript:;') {
                return;
            }
            event.preventDefault();

            if (subMenu) {
                const submenu = mobileNavigation.querySelector(`.navigation__mobile__submenu[data-menu="${menu}"][data-sub-menu="${subMenu}"][data-level="${parseInt(level) + 1}"]`);
                if (submenu) {
                    mobileNavigation.querySelectorAll(`.navigation__mobile__submenu:not([data-menu="${menu}"][data-sub-menu="${subMenu}"][data-level="${parseInt(level) + 1}"])`).forEach(sub => {
                        sub.classList.add('d-none');
                    });
                    mainMenu.classList.add('d-none');
                    submenu.classList.remove('d-none');
                }
            } else {
                const submenu = mobileNavigation.querySelector(`.navigation__mobile__submenu[data-menu="${menu}"][data-level="${parseInt(level) + 1}"]`);
                if (submenu) {
                    mobileNavigation.querySelectorAll(`.navigation__mobile__submenu:not([data-menu="${menu}"][data-level="${parseInt(level) + 1}"])`).forEach(sub => {
                        sub.classList.add('d-none');
                    });
                    mainMenu.classList.add('d-none');
                    submenu.classList.remove('d-none');
                }
            }
        });
    });

    mobileNavigationBack.forEach(goBack => {
        goBack.addEventListener('click', () => {
            const { lvl: level, menu } = goBack.dataset;

            const submenu = mobileNavigation.querySelector(`.navigation__mobile__submenu[data-menu="${menu}"][data-level="${parseInt(level) - 1}"]`);
            mobileNavigation.querySelectorAll(`.navigation__mobile__submenu:not([data-menu="${menu}"][data-level="${parseInt(level) - 1}"])`).forEach(sub => {
                sub.classList.add('d-none');
            });

            if (submenu) {
                submenu.classList.remove('d-none');
            } else {
                mainMenu.classList.remove('d-none');
            }
        });
    });

    function navigationOpen() {
        body.classList.add('no-scroll');
        header.classList.add('navigation__menu--active');
    }

    function navigationClose() {
        body.classList.remove('no-scroll');
        header.classList.remove('navigation__menu--active');
    }

    function closeAllMenus() {
        desktopNavigationLinks.forEach(link => {
            link.classList.remove('open-menu');
        });
    }

    function closeAllLvl2Menus() {
        lvl2NavigationLinks.forEach(link => {
            link.classList.remove('keep-open');
        });
    }
};
